import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import {
  List,
  Datagrid,
  DateField,
  NumberField,
  ReferenceField,
  TextField,
  ShowButton,
  CardActions,
  CreateButton,
  ExportButton,
  FunctionField,
  Filter,
  ReferenceInput,
  SelectInput,
  BulkDeleteButton,
} from 'react-admin';
import FullNameField from '../General/FullNameField';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import UploadBulkToFolio from './UploadBulkToFolio';
import { offeringCategory } from '../../helpers/mappings';

const conditionalOfferingStyles = {
  conditionalInsideRange: { color: 'green' },
  conditionalOutsideRange: { color: 'red' },
  nonConditional: { color: 'black' },
};

const ConditionalOfferField = withStyles(conditionalOfferingStyles)(({ classes, ...props }) => (
  <FunctionField
    {...props}
    render={record => `${record.isConditional ? offeringCategory.CONDITIONAL.label : offeringCategory.NORMAL.label}`}
  />
));

const ConditionalOfferElligibilityField = withStyles(conditionalOfferingStyles)(({ classes, ...props }) => {
  const {
    conditionalMinSharePrice: minSharePrice,
    conditionalMaxSharePrice: maxSharePrice,
    isConditional,
  } = props.record;
  const { pricePerShare } = props.record.offer;
  const isInsideRange = (minSharePrice <= pricePerShare && pricePerShare <= maxSharePrice);
  let className = 'nonConditional';
  let text = 'N/A';
  if (isConditional) {
    if (isInsideRange) {
      className = 'conditionalInsideRange'; text = 'Yes';
    } else {
      className = 'conditionalOutsideRange'; text = 'No';
    }
  }
  return (
    <FunctionField
      className={classes[className]}
      render={() => `${text}`}
    />
  );
});

const OfferOrderFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="Offer"
      source="offerId"
      reference="offerings"
      perPage={100}
      alwaysOn
    >
      <SelectInput
        optionText={choice => `${choice.name} (${_.values(offeringCategory).find(item => item.value === choice.category).label})`}
      />
    </ReferenceInput>
    <SelectInput
      label="Status"
      source="status"
      choices={[
        { id: 'created', name: 'Created' },
        { id: 'submitted', name: 'Submitted' },
        { id: 'deleted', name: 'Deleted' },
      ]}
      alwaysOn
    />
  </Filter>
);


const OfferOrderListActions = ({
  basePath,
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter,
}) => {
  const adminLevel = getAdminLevel();

  return (
    <CardActions>
      {filters && React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      }) }
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} /> : undefined
      }
      <ExportButton resource={resource} />
    </CardActions>
  );
};


const OfferBulkActions = props => (
  <Fragment>
    <UploadBulkToFolio {...props} />
    <BulkDeleteButton {...props} undoable={false} />
  </Fragment>
);

export default props => (
  <List
    {...props}
    title="Offer Orders"
    actions={<OfferOrderListActions />}
    filters={<OfferOrderFilter />}
    bulkActionButtons={
      [ADMIN_LEVELS.FULL_ADMIN, ADMIN_LEVELS.SUPERVISOR_ADMIN].includes(getAdminLevel()) ?
        <OfferBulkActions /> : false
    }
  >
    <Datagrid>
      <DateField source="createdAt" />
      <DateField label="Added to Folio at" source="folioPrivatePlacementOrderCreatedAt" />
      <TextField label="Name" source="offer.name" />
      <ConditionalOfferField label="Offer Category" />
      <ConditionalOfferElligibilityField label="Eligibile for Submission (Conditional)" />
      <ReferenceField label="User" source="userId" reference="users" linkType="show" sortable={false}>
        <FullNameField />
      </ReferenceField>
      <ReferenceField label="Account" source="accountNumber" reference="accounts" linkType={false} sortable={false}>
        <TextField source="accountNumber" />
      </ReferenceField>
      <TextField source="status" />
      <NumberField source="requestedTotalCurrencyAmt" options={{ style: 'currency', currency: 'USD' }} />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/OfferOrder/List.js